(() => {
    if (window.__videoScriptLoaderInitialized) return;
    window.__videoScriptLoaderInitialized = true;

    const loadScriptOnce = (srcUrl) => {
        if (!document.querySelector(`script[src="${srcUrl}"]`)) {
            const tag = document.createElement('script');
            tag.src = srcUrl;
            tag.async = true;
            document.head.appendChild(tag);
        }
    };

    const preventDuplicateScript = (srcUrl) => {
        const observer = new MutationObserver((_, obs) => {
            const scripts = document.querySelectorAll(`script[src="${srcUrl}"]`);
            if (scripts.length > 1) {
                scripts.forEach((el, index) => {
                    if (index > 0) el.remove();
                });
                obs.disconnect();
            }
        });

        observer.observe(document.head, { childList: true, subtree: true });
    };

    // Expose globally for inline handlers
    window.startVideo = (button) => {
        const videoContainer = button.closest('.video-container');
        const videoCover = videoContainer.querySelector('.video-cover');
        const iframe = videoContainer.querySelector('.video-frame');

        if (iframe) {
            if (videoCover) {
                videoCover.style.display = 'none';
            }

            const videoSrc = iframe.getAttribute('src');
            if (!videoSrc.includes('autoplay=1')) {
                const autoplaySrc = videoSrc.includes('?')
                    ? `${videoSrc}&autoplay=1`
                    : `${videoSrc}?autoplay=1`;
                iframe.setAttribute('src', autoplaySrc);
            }

            iframe.style.display = 'block';
        }
    };

    document.addEventListener("DOMContentLoaded", () => {
        loadScriptOnce("https://player.vimeo.com/api/player.js?dnt=1");
        loadScriptOnce("https://www.youtube-nocookie.com/iframe_api");

        preventDuplicateScript("https://player.vimeo.com/api/player.js?dnt=1");
        preventDuplicateScript("https://www.youtube-nocookie.com/iframe_api");

        const videoContainers = document.querySelectorAll(".video-container");
        videoContainers.forEach(container => {
            const cover = container.querySelector(".video-cover");
            const iframe = container.querySelector(".video-frame");

            if (!cover && iframe) {
                iframe.style.display = 'block';
            }
        });
    });
})();
